import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { POLLING_DEFAULT_CONFIG } from '../database/EntityManager';
import SocketLocation from '../database/models/SocketLocation';
import { BIG_PARK_POLLING_DURATION, CASUAL_PARK_POLLING_DURATION } from '../services/devices-manager.service';
import { SocketService } from '../services/socket.service';
import { interval } from '../utils/interval';
import { AccountStateService } from './account-state.service';
import { LocationsService } from './locations.service';

const BUFFER_INTERVAL = 2000;

@Injectable({
  providedIn: 'root',
})
class SocketLocationsService {
  public values$ = new BehaviorSubject<Record<number, SocketLocation>>({});
  public changedValues$ = new BehaviorSubject<Record<number, SocketLocation>>(null);

  private _socketService = inject<SocketService<SocketLocation>>(SocketService);
  private _accountStateService = inject(AccountStateService);
  private _locationsService = inject(LocationsService);
  private _dataBuffer: SocketLocation[] = [];

  public init() {
    if (this._accountStateService.$account().broker_connection) {
      this._socketService.connect({ entity: 'broker_device', fields: '*' });

      interval.set(async () => {
        if (this._dataBuffer.length) {
          const values: Record<number, SocketLocation> = {};

          this._dataBuffer.forEach(device => {
            values[device.fk_device] = new SocketLocation(device);
          });

          this.changedValues$.next(values);
          this.values$.next({ ...this.values$.value, ...values });

          this._dataBuffer = [];
        }
      }, BUFFER_INTERVAL);

      this._socketService.socket.subscribe({
        next: async message => {
          if (message.action === 'data') {
            this._dataBuffer.push(message.content);
          }
        },
      });

      this._socketService.status$.subscribe(status => {
        switch (status.state) {
          case 'reconnecting':
            this._initBackup();
            break;
          case 'connected':
            this.rollbackBackup();
            break;
        }
      });
    } else {
      this._initBackup();
    }
  }

  public clear() {
    this.values$.next({});
    this.changedValues$.next({});
    this._dataBuffer = [];

    this._socketService.disconnect();
  }

  private rollbackBackup() {
    this._locationsService.updatePolling({
      duration: this._accountStateService.$isRenault()
        ? BIG_PARK_POLLING_DURATION
        : POLLING_DEFAULT_CONFIG.duration,
    });
  }

  private _initBackup() {
    console.debug('[Websocket] - 🔀 location api take the lead due to unavailability of websocket.');

    this._locationsService.updatePolling({
      duration: this._accountStateService.$isRenault() ? BIG_PARK_POLLING_DURATION : CASUAL_PARK_POLLING_DURATION,
    });
  }
}

export default SocketLocationsService;
